import { Component, OnInit } from '@angular/core';
import {AuthService} from "../services/auth.service";
import {JwtService} from "../services/jwt.service";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  constructor(public jwtService: JwtService) { }

  ngOnInit() {
  }
}
